import { __assign, __extends } from "tslib";
/**
 * Created by Kamil.Adamuszek on 2016-03-22.
 */
import BSSAbstractComponent from '../../bss-abstract-component/js/bss-abstract-component.js';
import BSSInfoHintComponent from '../../bss-infohint-component/js/bss-infohint-component.js';
import buttonTemplate from '../template/button.hbs';
import linkTemplate from '../template/link.hbs';
import logger from '@main/externals/bss-package-logger/js/logger';
var buttonTemplates = {
    defaultTemplate: buttonTemplate,
    link: linkTemplate,
};
/**
 * BSSButtonComponent class
 */
var BSSButtonComponent = /** @class */ (function (_super) {
    __extends(BSSButtonComponent, _super);
    /**
     * @param {String} [_entityTemplate=null] _entityTemplate entity template
     * @param {String} [containerSelector=null] containerSelector component container selector
     * @param {Object} [config=null] configuration of component
     * @param {EventManager} [eventManager=null] instance of _EventManager
     * @param {Formatter} [formatter=null] instance of Formatter
     * @param {Resolution} [resolution=null] Resolution class for width breakpoint handling
     * @param {Object} [toolbox=null] toolbox object
     */
    function BSSButtonComponent(_entityTemplate, containerSelector, config, eventManager, formatter, resolution, toolbox) {
        if (_entityTemplate === void 0) { _entityTemplate = null; }
        if (containerSelector === void 0) { containerSelector = null; }
        if (config === void 0) { config = null; }
        if (eventManager === void 0) { eventManager = null; }
        if (formatter === void 0) { formatter = null; }
        if (resolution === void 0) { resolution = null; }
        if (toolbox === void 0) { toolbox = null; }
        var _this = this;
        if (config.onClickEvent === '' ||
            config.onClickEvent === null ||
            typeof config.onClickEvent === 'undefined') {
            throw "Error: Event node is empty or doesn't exist";
        }
        _this = _super.call(this, _entityTemplate, containerSelector, config, eventManager, formatter, resolution, buttonTemplates, toolbox) || this;
        /**
         * @desc flag to turn on print functionality
         * @type {boolean}
         * @private
         */
        _this._printButton = !!_this._config.printButton;
        /**
         * @desc onClickEvent name
         * @type {string}
         * @private
         */
        _this._onClickEventName = _this._config.onClickEvent;
        /**
         * @desc flag to turn on replace @entityInstanceId@
         */
        if (_this._config.replaceEntityInstanceId) {
            _this._config = JSON.parse(JSON.stringify(_this._config).replace(/@entityInstanceId@/gi, _this._config.entityInstanceId));
        }
        /**
         * @desc flag to turn on render functionality
         * @type {boolean}
         * @private
         */
        _this._renderTemplate = !!_this._config.renderTemplate;
        /**
         * @desc flag to turn on address lookup functionality
         * @type {boolean}
         * @private
         */
        _this._addressLookup = !!_this._config.addressLookup;
        /**
         * @desc print view container id
         * @type {string}
         * @private
         */
        _this._printContainerId = _this._config.printContainerId;
        /**
         * @desc name of tag event
         * @type {string}
         * @private
         */
        _this._tagEventName = _this._config.tagEventName
            ? _this._config.tagEventName
            : null;
        /**
         * @desc class using for window print style, default value is 'bss-print-view'
         * @type {string}
         * @private
         */
        _this._printClass = _this._config.printClass
            ? _this._config.printClass
            : 'bss-print-view';
        _this._isInPopup = _this._toolbox
            .$('[data-toggle="modal"], .modal-body')
            .has('#' + _this._componentScope.attr('id')).length;
        _this._globalHtmlBody = _this._isInPopup
            ? _this._toolbox.$('[data-toggle="modal"], .modal-body')
            : _this._htmlBody;
        _this._addEventListeners();
        _this._componentVersion = '@@name ver. @@version';
        logger.info('ButtonComponent ' +
            _this._config.componentId +
            ' => constructor : componentId: ' +
            config.componentId +
            ' | Params: ', _entityTemplate, containerSelector, config, eventManager, formatter, resolution, logger, toolbox);
        if (_this._config.hintText || _this._config.hintTitle) {
            _this._infohint = new BSSInfoHintComponent(_entityTemplate, '.' + _this._config.componentId + '_info-hint-container', config, eventManager, formatter, resolution, toolbox);
        }
        if (_this._config.componentTemplate === 'link' && 'href' in _this._config) {
            _this._bindHrefUrl();
            _this._eventManager.subscribe('bss-entity-update-' +
                _this._config.entityInstanceId +
                '-' +
                _this._config.productId[Object.keys(_this._config.productId)[0]], _this._bindHrefUrl.bind(_this), _this.subscriberPrefix + _this._config.componentId);
        }
        /**
         * @desc jQuery instance of button tag within current component
         * @type {jQuery}
         * @private
         */
        _this.$btnEl = _this._componentScope.find("#".concat(_this._config.componentId, "_btn"));
        return _this;
    }
    /**
     * Add disabled button state by adding '--disabled' class
     */
    BSSButtonComponent.prototype.disableBtn = function () {
        logger.info('ButtonComponent: ' +
            this._config.componentId +
            ' => function :  disableBtn');
        this._componentScope.addClass('bss-button_btn--disabled');
    };
    /**
     * Add active button state by removing '--disabled' class
     */
    BSSButtonComponent.prototype.enableBtn = function () {
        logger.info('ButtonComponent: ' +
            this._config.componentId +
            ' => function :  enableBtn');
        this._componentScope.removeClass('bss-button_btn--disabled');
    };
    /**
     * @desc bind href attribute
     * @private
     */
    BSSButtonComponent.prototype._bindHrefUrl = function () {
        logger.info('ButtonComponent: ' +
            this._config.componentId +
            ' => function :  _bindHrefUrl');
        var linkElement = this._componentScope.find('a');
        var hrefParams;
        var hrefObject;
        var hrefUrl;
        if (this._toolbox.$(linkElement.data('href')).data('text')) {
            hrefParams = this._toolbox
                .$(linkElement.data('href'))
                .data('text')
                .split('.');
            hrefUrl = this._config.texts[hrefParams[0]][hrefParams[1]];
        }
        else if (this._toolbox.$(linkElement.data('href')).data('value')) {
            hrefParams = this._toolbox.$(linkElement.data('href')).data('value')
                ? this._toolbox.$(linkElement.data('href')).data('value').split('.')
                : null;
            hrefObject = this._config.resultData[hrefParams[0]][hrefParams[1]][hrefParams[2]].filter(function (obj) {
                return obj.name === hrefParams[3];
            });
            hrefUrl = hrefObject.length ? hrefObject[0][hrefParams[4]] : '';
        }
        else {
            hrefParams = null;
            hrefUrl = null;
        }
        if (hrefParams) {
            linkElement.attr('href', hrefUrl);
        }
        return hrefUrl;
    };
    BSSButtonComponent.prototype._showHideContainers = function () {
        var _this = this;
        if (this._config.onClickEvent.includes('show-container')) {
            var firstHiddenId_1 = this._config.containersToShow.find(function (id) {
                return _this._toolbox.$("#".concat(id)).hasClass('hidden');
            });
            if (firstHiddenId_1) {
                var $el_1 = this._toolbox.$("#".concat(firstHiddenId_1));
                // włącz pola i pokaż kontener
                var $fields = $el_1.find('input[type="number"]');
                var $selects = $el_1.find('select');
                var $radios = $el_1.find('input[type="radio"]');
                $fields.removeAttr('disabled');
                $selects.removeAttr('disabled');
                $radios.removeAttr('disabled');
                $el_1.removeClass('hidden');
                $fields.val('');
                $selects.prop('selected', false);
                $selects.trigger('change');
                $radios.prop('checked', false);
                $radios.trigger('change');
                var triggerUnselectIfNeeded = function () {
                    // spróbuj wyciągnąć numer sekcji z ID kontenera (np. "...2", "...3")
                    var match = String(firstHiddenId_1).match(/(\d+)(?!.*\d)/);
                    var sectionNumber = match
                        ? _this._config.containersToShow.indexOf("thirdStepFormGrid_row-".concat(parseInt(match[1], 10))) + 1
                        : null;
                    if (parseInt(match[1], 10) < 9)
                        sectionNumber += 1;
                    if (sectionNumber && sectionNumber > 1) {
                        // możliwe ID dropdownów, które chcesz „odznaczyć”
                        var candidates = [
                            "dropdownIncomes".concat(sectionNumber),
                            "dropdownExpenses".concat(sectionNumber),
                            "dropdownFrequency".concat(sectionNumber),
                            "dropdownExpenseFrequency".concat(sectionNumber),
                        ];
                        // wybierz tylko istniejące w DOM
                        var existingSelectors = candidates
                            .filter(function (sel) { return $el_1.find("#".concat(sel, "_custom-select")).length > 0; })
                            .map(function (sel) { return "#".concat(sel, "_custom-select"); });
                        if (existingSelectors.length) {
                            var $targets = _this._toolbox.$(existingSelectors.join(', '));
                            $targets.each(function (i, el) {
                                var $target = _this._toolbox.$(el);
                                var dropdownId = el.id.split('_')[0];
                                _this._eventManager.publish("bss-unselect-dropdown-".concat(dropdownId, "-").concat(_this._config.entityInstanceId), "".concat(_this._config.componentType, "-").concat(_this._config.componentId), $target, // pojedynczy element
                                false);
                            });
                        }
                    }
                };
                triggerUnselectIfNeeded();
                var toggleRequired = function ($elements, isRadio) {
                    if (isRadio === void 0) { isRadio = false; }
                    // unikalne nazwy dla grup radiobuttonów
                    if (isRadio) {
                        var names = [];
                        var seen = new Set();
                        for (var i = 0; i < $elements.length; i++) {
                            var name_1 = $elements.eq(i).attr('name');
                            if (!seen.has(name_1)) {
                                seen.add(name_1);
                                names.push(name_1);
                            }
                        }
                        for (var i = 0; i < names.length; i++) {
                            var name_2 = names[i];
                            var $group = _this._formSelector.find("input[type=\"radio\"][name=\"".concat(name_2, "\"]"));
                            $group.removeClass('filled');
                            var isHidden = $group.first().closest('.oa-form-row.hidden').length > 0;
                            var isChecked = $group.is(':checked');
                            var hasFilledClass = $group.hasClass('filled');
                            if (isHidden || isChecked || hasFilledClass) {
                                $group.removeAttr('required').addClass('filled');
                            }
                            else {
                                $group.attr('required', 'required');
                            }
                        }
                        return;
                    }
                    // inputy, selecty
                    $elements.each(function () {
                        var $el = $(this);
                        $el.removeClass('filled');
                        var isHidden = $el.closest('.oa-form-row.hidden').length > 0;
                        var hasValue = !!$el.val();
                        var hasFilledClass = $el.hasClass('filled');
                        if (isHidden || hasValue || hasFilledClass) {
                            $el.removeAttr('required').addClass('filled');
                        }
                        else {
                            $el.attr('required', 'required');
                        }
                    });
                };
                // 🔹 1. SELECTY income/expense (Type + Frequency)
                toggleRequired.call(this, $el_1.find('select[name^="incomeType"], select[name^="expenseType"], ' +
                    'select[name^="incomeFrequency"], select[name^="expenseFrequency"]'));
                // 🔹 2. RADIO incomeNetOrGross / expenseNetOrGross
                toggleRequired.call(this, $el_1.find('input[type="radio"][name^="incomeNetOrGross"], ' +
                    'input[type="radio"][name^="expenseNetOrGross"]'), true);
                // 🔹 3. INPUTY number: incomeAmount + expenseAmount
                toggleRequired.call(this, $el_1.find('input[type="number"][name^="incomeAmount"], ' +
                    'input[type="number"][name^="expenseAmount"]'));
            }
        }
        else if (this._config.onClickEvent.includes('hide-container')) {
            this._toolbox
                .$("#".concat(this._config.showContainer))
                .find('input, select, radio')
                .attr('disabled', 'disabled')
                .removeClass('filled');
            this._toolbox.$("#".concat(this._config.showContainer)).addClass('hidden');
        }
        var allVisible = this._config.containersToShow.every(function (id) { return !_this._toolbox.$("#".concat(id)).hasClass('hidden'); });
        var $button = this._toolbox.$("#".concat(this._config.buttonId));
        if (allVisible) {
            $button.addClass('bss-button_btn--disabled');
        }
        else {
            $button.removeClass('bss-button_btn--disabled');
        }
    };
    /**
     * @desc publish event from configuration, print window view if print params set
     * @private
     */
    BSSButtonComponent.prototype._onClickEvent = function (event) {
        var _this = this;
        logger.info('ButtonComponent: ' +
            this._config.componentId +
            ' => function :  _onClickEvent');
        event.currentTarget.blur();
        var currentProductId = this._toolbox.currentProductId;
        if (this._config.stopPropagation) {
            event.stopPropagation();
        }
        if (this._config.onClickEvent.includes('show-container') ||
            this._config.onClickEvent.includes('hide-container')) {
            this._showHideContainers();
            return;
        }
        if (this._config.onClickEvent.includes('bss-learn-more-button')) {
            this._config.resultData = this._toolbox.resultDataFlat;
            this._publishTaggingEvents('learnMoreButton_click');
        }
        if (this._config.onClickEvent.includes('@productId@') &&
            currentProductId !== null) {
            this._onClickEventName = this._config.onClickEvent.replace('@productId@', currentProductId);
        }
        if (this._config.sendEventToServer === false) {
            if (this._tagEventName) {
                this._publishTaggingEvents(this._tagEventName);
            }
            this._publishEvents(this._onClickEventName, this._config.eventData || {});
            if (this._printButton) {
                this._triggerPrint();
            }
            if (this._addressLookup) {
                var lookupData = this._config.addressLookup;
                this._eventManager.publish('bss-button-lookup-event', this._config.componentType + ' ' + this._config.componentId, lookupData);
                if (this._toolbox.$(this._config.focusOnInputId).length > 0) {
                    this._globalHtmlBody.animate({
                        scrollTop: this._toolbox
                            .$(this._config.focusOnInputId)
                            .parent()
                            .parent()
                            .offset().top,
                    });
                    this._toolbox.$(this._config.focusOnInputId).focus();
                }
            }
            if (this._renderTemplate) {
                if (this._toolbox.resultDataFlat && this._config.productId) {
                    var resultData = '';
                    if (this._config.requestConfiguration.type === 'POST') {
                        resultData = JSON.stringify({
                            data: this._toolbox.resultDataFlat[this._config.productId[0]],
                        });
                    }
                    else if (this._config.requestConfiguration.data) {
                        resultData = this._config.requestConfiguration.data;
                    }
                    var newUrl = this._generateUrlFromRespond();
                    if (this._config.requestConfiguration.download) {
                        this._renderCallback({}, newUrl);
                    }
                    else {
                        this.createSimpleRequest({
                            success: this._renderCallback,
                            error: function () {
                                if (_this.activeWindowOpen) {
                                    _this.activeWindowOpen.close();
                                }
                            },
                            url: newUrl || this._config.requestConfiguration.url,
                            data: resultData,
                        });
                    }
                }
                else {
                    logger.error('ButtonComponent: ' +
                        this._config.componentId +
                        ' => function :  _onClickEvent - no resultDataFlat');
                }
            }
        }
        else {
            this._handleStandardOnClick();
        }
    };
    /**
     * Triggers default onClickEvent with resultData or requestResponseData
     * @see useResponseData flag
     * @private
     */
    BSSButtonComponent.prototype._handleStandardOnClick = function () {
        var _this = this;
        var _a, _b;
        logger.info('ButtonComponent: ' +
            this._config.componentId +
            ' => function :  _handleStandardOnClick');
        if (((_b = (_a = this._config.actionAfterResponse) === null || _a === void 0 ? void 0 : _a.openPage) === null || _b === void 0 ? void 0 : _b.newTab) === 'true') {
            this.activeWindowOpen = window.open('', '_blank');
        }
        var productId = this._config.productId[0];
        var resultData = this._config.resultData[productId];
        var _c = this._config.requestConfiguration || {}, useResponseData = _c.useResponseData, url = _c.url, isAdvancedRequest = _c.isAdvancedRequest, requestData = _c.requestData;
        if (!useResponseData) {
            this._publishEvents(this._onClickEventName, resultData);
        }
        if (url) {
            var success = function (responseData) {
                if (useResponseData) {
                    _this._publishEvents(_this._onClickEventName, responseData);
                }
                _this._openWindowCallback(responseData);
            };
            var flatProductData = this._toolbox.resultDataFlat[this._toolbox.currentProductId];
            var usedCarsRequestData = __assign(__assign({}, requestData), { parameters: { financeQuoteId: flatProductData.quoteId } });
            if (resultData === null || resultData === void 0 ? void 0 : resultData.flowParams)
                resultData.flowParams = JSON.stringify(resultData.flowParams);
            var params = this._toolbox.currentEntity.type === 'usedCarsSimulator'
                ? usedCarsRequestData
                : resultData;
            if (isAdvancedRequest) {
                this._eventManager.publish("bss-connector-recived-desired-data-".concat(this._config.entityInstanceId), this._config.componentType + '-' + this._config.componentId, {
                    url: url,
                    params: params,
                    success: success,
                    error: function () {
                        _this._eventManager.publish("bss-entity-critical-error-".concat(_this._config.entityInstanceId), _this._config.componentType + '-' + _this._config.componentId, { errorCode: 'DEFAULT_ERROR' }, false);
                    },
                }, false);
            }
            else {
                this.createSimpleRequest({
                    success: success,
                    error: function () {
                        if (_this.activeWindowOpen) {
                            _this.activeWindowOpen.close();
                        }
                    },
                    url: url,
                    data: JSON.stringify(params),
                });
            }
        }
    };
    /**
     * Publish one ore more events.
     * @param onClickEvent
     * @param data
     * @private
     */
    BSSButtonComponent.prototype._publishEvents = function (onClickEvent, data) {
        var _this = this;
        var _a, _b, _c, _d, _f, _g;
        logger.info('ButtonComponent: ' +
            this._config.componentId +
            ' => function :  _publishEvents | Params: ', onClickEvent, data);
        var productId = this._config.productId[0];
        var url = '';
        if (onClickEvent.includes('open-external-link')) {
            url = this._config.texts[productId][this._config.openUrl];
            var configuration = {
                url: url,
            };
            this._eventManager.publish(onClickEvent, this._config.componentType + ' ' + this._config.componentId, configuration, this._config.isPublicEvent, (_b = (_a = this._config) === null || _a === void 0 ? void 0 : _a.isForcedEvent) !== null && _b !== void 0 ? _b : false);
        }
        else if (onClickEvent.includes('open')) {
            if (this._config.resultData) {
                var _h = this._config.resultData[productId], price_1 = _h.price, duration_1 = _h.duration, balloon_1 = _h.balloon, downpayment_1 = _h.downpayment, productCode_1 = _h.productCode, brand_1 = _h.brand;
                this.createSimpleRequest({
                    success: function (data) {
                        var _a, _b;
                        var configuration = {
                            amount: price_1,
                            duration: duration_1,
                            finalTerm: balloon_1,
                            downpayment: downpayment_1,
                            productCode: productCode_1,
                            tyCode: data.ConfigurationCode,
                            brand: brand_1,
                            url: url,
                        };
                        _this._eventManager.publish(onClickEvent, _this._config.componentType + ' ' + _this._config.componentId, configuration, _this._config.isPublicEvent, (_b = (_a = _this._config) === null || _a === void 0 ? void 0 : _a.isForcedEvent) !== null && _b !== void 0 ? _b : false);
                        var publisherName = "".concat(_this._config.componentType, "-").concat(_this._config.componentId);
                        _this._eventManager.publish("bss-hide-entity-overlay-".concat(_this._config.entityInstanceId), publisherName);
                    },
                    error: function () { },
                    dataType: 'json',
                    url: this._config.url,
                    data: JSON.stringify(this._config.initConfiguration),
                });
            }
        }
        if (typeof onClickEvent === 'string') {
            this._eventManager.publish(onClickEvent, this._config.componentType + ' ' + this._config.componentId, data, this._config.isPublicEvent, (_d = (_c = this._config) === null || _c === void 0 ? void 0 : _c.isForcedEvent) !== null && _d !== void 0 ? _d : false);
        }
        else if (onClickEvent.length) {
            for (var _i = 0, onClickEvent_1 = onClickEvent; _i < onClickEvent_1.length; _i++) {
                var event_1 = onClickEvent_1[_i];
                this._eventManager.publish(event_1, this._config.componentType + ' ' + this._config.componentId, data, this._config.isPublicEvent, (_g = (_f = this._config) === null || _f === void 0 ? void 0 : _f.isForcedEvent) !== null && _g !== void 0 ? _g : false);
            }
        }
    };
    /**
     * Publish tagging events.
     * @param tagEventName
     * @param data
     * @private
     */
    BSSButtonComponent.prototype._publishTaggingEvents = function (tagEventName) {
        logger.info('ButtonComponent: ' +
            this._config.componentId +
            ' => function :  _publishTaggingEvents | Params: ', tagEventName);
        this._publishDxpTaggingEvents(tagEventName);
    };
    /**
     * Publish DXP tagging events.
     * @param {String | Array} tagEventNames
     * @private
     */
    BSSButtonComponent.prototype._publishDxpTaggingEvents = function (tagEventNames) {
        var _this = this;
        var publish = function (tagEventName) {
            var _a, _b;
            (_b = (_a = _this._toolbox.dxpTagging) === null || _a === void 0 ? void 0 : _a[_this._toolbox.currentEntity.entityId]) === null || _b === void 0 ? void 0 : _b.publish(tagEventName, __assign(__assign({}, _this._config.resultData[_this._config.productId[0]]), { triggerName: 'bss-button' }), _this._config.taggingTriggerName || '');
        };
        if (Array.isArray(tagEventNames)) {
            tagEventNames.forEach(function (tagEventName) {
                publish(tagEventName);
            });
        }
        else {
            publish(tagEventNames);
        }
    };
    /**
     * @desc Function callback posible trigger download and call a event
     * @param data
     * @private
     */
    BSSButtonComponent.prototype._renderCallback = function (data, newUrl) {
        if (this._config.requestConfiguration.download) {
            var link = document.createElement('a');
            link.href = newUrl ? newUrl : this._config.requestConfiguration.url;
            link.setAttribute('target', this._config.requestConfiguration.target
                ? this._config.requestConfiguration.target
                : '_blank');
            if (this._config.requestConfiguration.hasOwnProperty('fileName')) {
                link.setAttribute('download', this._config.requestConfiguration.fileName);
            }
            document.body.appendChild(link);
            link.click();
        }
        var onEventsEnd = this._config.requestConfiguration.onEventsEnd;
        if (onEventsEnd) {
            this._publishEvents(onEventsEnd, data);
        }
    };
    /**
     * @desc Open new window
     * @param data
     * @private
     */
    BSSButtonComponent.prototype._openWindowCallback = function (data) {
        var actionAfterResponse = this._config.actionAfterResponse;
        if (actionAfterResponse !== undefined) {
            var options = actionAfterResponse.openPage;
            var urlToOpen = data[options.urlPropertyName];
            if (options.newTab === 'true') {
                this.activeWindowOpen.location.href = urlToOpen;
            }
            else {
                window.open(urlToOpen, '_self');
            }
        }
    };
    /**
     * @desc Trigger native print method.
     * @private
     */
    BSSButtonComponent.prototype._triggerPrint = function () {
        var $bodyContainer = this._toolbox.$('body');
        $bodyContainer.addClass(this._printClass);
        // clone print content element
        var $insertContent = this._toolbox
            .$('#' + this._printContainerId)
            .clone();
        // set print class to print only cloned content
        if (this._printContainerId && $insertContent) {
            $bodyContainer.append($insertContent);
            $insertContent.addClass(this._printClass + '_bss-print');
        }
        window.print();
        $bodyContainer.removeClass(this._printClass);
        // remove print content cloned element
        if (this._printContainerId && $insertContent) {
            $insertContent.remove();
        }
    };
    /**
     * @desc Check in url for not inserted values, and bind them.
     * @returns {*}
     * @private
     */
    BSSButtonComponent.prototype._generateUrlFromRespond = function () {
        try {
            if (this._toolbox.currentEntity &&
                this._config.urlFromRespond &&
                this._toolbox.currentEntity.commonURLs[this._config.urlFromRespond]) {
                var url = this._toolbox.currentEntity.commonURLs[this._config.urlFromRespond];
                var regx = /{(\w+)(, ?(\w+))?}/g;
                if (url.match(regx)) {
                    return url.replace(regx, this._replaceValues.bind(this, this._toolbox.resultDataFlat[this._config.productId[0]]));
                }
                else {
                    return url;
                }
            }
        }
        catch (_e) {
            return null;
        }
        return null;
    };
    /**
     * @desc Replace values by specific patern.
     * @param resultData
     * @param value
     * @param param1
     * @param param_
     * @param param2
     * @returns {string}
     * @private
     */
    BSSButtonComponent.prototype._replaceValues = function (resultData, _value, param1) {
        var valueKey = param1;
        var resultValue = '';
        if (resultData.hasOwnProperty(valueKey)) {
            resultValue = resultData[valueKey];
        }
        return resultValue;
    };
    /**
     * @desc subscribes events
     * @private
     */
    BSSButtonComponent.prototype._addEventListeners = function () {
        logger.info('ButtonComponent: ' +
            this._config.componentId +
            ' => function :  _addEventListeners');
        this._componentScope
            .find('#' +
            this._config.componentId +
            '_btn, #' +
            this._config.componentId +
            '_link')
            .on('click.' + this._config.componentId, this._onClickEvent.bind(this));
    };
    /**
     *
     * @public method
     * @desc destroys infohint and call super method
     */
    BSSButtonComponent.prototype.destroy = function () {
        logger.info('ButtonComponent: ' +
            this._config.componentId +
            ' => function :  _destroy');
        if (typeof this._infohint !== 'undefined') {
            this._infohint.destroy();
        }
        _super.prototype.destroy.call(this);
    };
    return BSSButtonComponent;
}(BSSAbstractComponent));
export default BSSButtonComponent;
